import { APIError } from '../errors/APIError';
import { useAPIMutation, useAPIQuery } from '../useAPIProvider';

export const useServiceRequests = (mspId?: string, customerId?: string) => {
  return useAPIQuery(['getServiceRequests', mspId, customerId], async client => {
    if (!mspId || !customerId) return [];

    const response = await client.serviceRequests.getServiceRequests({ params: { mspId, customerId } });
    if (response.status !== 200) throw APIError.fromResponse(response);
    return response.body;
  });
};

export const useCreateServiceRequest = () => {
  return useAPIMutation((client, queryClient) => {
    return async (params: Parameters<typeof client.serviceRequests.createServiceRequest>[0]) => {
      const response = await client.serviceRequests.createServiceRequest(params);
      if (response.status !== 201 && response.status !== 200) throw APIError.fromResponse(response);
      await queryClient.invalidateQueries(['getServiceRequests']);
      return response.body;
    };
  });
};

export const useGetServiceRequestTypes = () => {
  return useAPIQuery(['getServiceRequestTypes'], async client => {
    const response = await client.serviceRequests.getServiceRequestTypes();
    if (response.status !== 200) throw APIError.fromResponse(response);
    return response.body;
  });
};
